<template>
  <div>
    <div style="box-shadow: 0px 4px 20px 0px rgba(0,0,0,0.1);margin-bottom: 1px;">
      <div class="navbar">
        <div class="left-section">
          <img :src="websitBanner" class="logo" />
        </div>
        <div class="right-section">
          <ul class="nav-links">
            <!-- 首页 -->
            <li @click="toUrl('home')">
              <span
                :class="{ active: activeTab === 'home' }"
                class="nav-item"
              >
                首页
              </span>
            </li>

            <li
              v-for="(item, i) in columnTreeList"
              :key="i"
              @click="toUrl(item)"
            >
              <span
                :class="{ active: activeTab == item.id }"
                class="nav-item"
              >
                {{ item.columnName }}
              </span>
            </li>

            <li class="login-li" v-if="user">
              <div class="user-avatar-container" @mouseenter="showDropdown = true" @mouseleave="showDropdown = false">
                <img :src="filePath+'/'+avatar" v-if="avatar" class="common-img"/>
                <img src="../assets/newstudycenter/morentouxiang2.png" v-if="!avatar" class="common-img"/>

                <div class="user-dropdown" v-show="showDropdown">
                  <ul class="dropdown-menu">
                    <li class="dropdown-item" @click="goToProfile()">
                      <span class="item-text">修改资料</span>
                    </li>
                    <li class="dropdown-item" @click="goToAccount()">
                      <span class="item-text">帐号安全</span>
                    </li>
                    <li class="dropdown-divider"></li>
                    <li class="dropdown-item logout-item" @click="signOut">
                      <span class="item-text">安全退出</span>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <li class="login-li" v-else>
              <span class="login-font">
                <span @click="$login.show()" class="register-span">登录</span>&nbsp;/&nbsp;<span class="register-span" @click="registerAccount">注册</span>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="main-core-content" :class="{ 'full-width': $route.meta.fullWidth }">
      <slot></slot>
    </div>

    <div>
      <Footer></Footer>
    </div>
    <!-- AI 助手悬浮入口，只在登录后布局内显示 -->
<!--    <ai-assistant></ai-assistant>-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import apis from '@/apis/student/home'
import Clickoutside from 'element-ui/src/utils/clickoutside'
import getLocal from '@/common/cookie'
import { JSEncrypt } from 'jsencrypt'
import constant from '@/constant'
import router from '../router'
import AiAssistant from '@/components/AiAssistant'
export default {
  directives: { Clickoutside },
  components: { AiAssistant },
  data () {
    return {
      title: '',
      filePath: constant.URL_IMG + '/ts-fe/media/viewer/',
      dictList: [],
      avatar: null,
      userInfo: null,
      activeTab: 'home', // 默认激活首页
      showDropdown: false // 控制下拉菜单显示/隐藏
    }
  },
  computed: {
    ...mapGetters(['columnTreeList', 'activeIndex', 'user', 'websitBanner'])
  },
  watch: {
    user (newVal) {
      if (newVal) {
        this.userInfo = newVal
        this.avatar = newVal.previewAssetId
      } else {
        this.updateUserInfo()
      }
    }
  },
  created () {
    this.updateUserInfo()
    this.syncActiveTabFromRoute()
  },
  mounted () {
    // 监听路由变化，自动同步 activeTab
    this.$router.afterEach((to, from) => {
      this.syncActiveTabFromRoute()
    })
  },
  methods: {
    getLocalUserInfo () {
      const keyValue = localStorage.getItem('user')
      return keyValue !== null && keyValue !== undefined && keyValue.indexOf('[object Object]') <= -1
        ? JSON.parse(keyValue)
        : null
    },
    updateUserInfo () {
      this.userInfo = this.getLocalUserInfo()
      if (this.userInfo && this.userInfo.previewAssetId) {
        this.avatar = this.userInfo.previewAssetId
      }
    },
    syncActiveTabFromRoute () {
      const currentPath = this.$route.path
      if (currentPath === '/') {
        this.activeTab = 'home'
      }
      // 只要是/studycenter路径（不管有没有menu参数），都高亮学习中心/个人中心
      else if (currentPath.includes('/studycenter')) {
        const personalCenterItem = this.columnTreeList.find(item =>
          item.columnName === '个人中心' || item.columnName === '学习中心'
        )
        if (personalCenterItem) {
          this.activeTab = personalCenterItem.id
        } else {
          this.activeTab = 'home' // 兜底
        }
      }
      // 处理其他带 columnId 的路由
      else {
        const columnId = this.$route.params.columnId || this.$route.query.columnId || this.activeIndex
        if (columnId) {
          this.activeTab = columnId
        } else {
          this.activeTab = 'home'
        }
      }
    },
    goToProfile () {
      this.showDropdown = false
      const personalCenterItem = this.columnTreeList.find(item =>
        item.columnName === '个人中心' || item.columnName === '学习中心'
      )
      if (personalCenterItem) {
        this.activeTab = personalCenterItem.id
        this.$store.commit('SET_ACTIVEINDEX', personalCenterItem.id)
      }
      this.$router.push({
        path: '/studycenter',
        query: { menu: 5 }
      }, undefined, { force: true })
    },
    goToAccount () {
      this.showDropdown = false
      const personalCenterItem = this.columnTreeList.find(item =>
        item.columnName === '个人中心' || item.columnName === '学习中心'
      )
      if (personalCenterItem) {
        this.activeTab = personalCenterItem.id
        this.$store.commit('SET_ACTIVEINDEX', personalCenterItem.id)
      }
      this.$router.push({
        path: '/studycenter',
        query: { menu: 6 }
      }, undefined, { force: true })
    },
    signOut () {
      apis.logout().then(res => {
        const { code, msg } = res
        if (code === 0) {
          this.$store.dispatch('logout')
          this.$store.dispatch('removeRedirect')
          this.$store.commit('SET_USER')
          this.$cookie.delete('token')
          this.$store.commit('SET_ACTIVEINDEX', '')
          localStorage.removeItem('accessToken')
          this.userInfo = null
          this.avatar = null
          this.$message.success(msg)
          this.$nextTick(() => {
            this.activeTab = 'home' // 退出时重置激活状态
            this.$router.push({ path: '/' })
          })
        } else {
          this.$message.warning(msg)
        }
      })
    },
    registerAccount () {
      router.push({
        path: '/register'
      })
    },
    toUrl (item) {
      if (item === 'home') {
        this.activeTab = 'home'
        this.$store.commit('SET_COLUMNITEM', [])
        this.$store.commit('SET_COLUMNITEM_PARENT', [])
        this.$store.commit('SET_ACTIVEINDEX', '')
        this.$router.push({ path: '/' })
        return
      }

      if (item) {
        if (item.isExtralinks === 1) {
          var url = item.extralinksUrl
          const token = getLocal.getCookie('token')
          const encryptor = new JSEncrypt()
          encryptor.setPublicKey(constant.PUBLICKEY)
          if (token && url.indexOf('ndlink.cn') > 0) {
            if (this.user) {
              var data = {
                mobile: this.user.mobile,
                realName: this.user.realName,
                openid: this.user.openid,
                unionid: this.user.unionid
              }
              url = url + '?code=saas&key=' + encryptor.encrypt(JSON.stringify(data))
            }
          }

          if (token && url.indexOf('iacove.com') > 0) {
            var iacoveUrl = 'nationCode=86&mobile=' + this.user.mobile + '&redirectUrl=' + url
            var key = encryptor.encrypt(iacoveUrl)
            url = 'https://iacove.com/user/thirdLoginMobile?encryptCode=' + encodeURIComponent(key)
          }
          if (item.openWith === 2) {
            window.open(url)
          } else {
            window.location.href = url
          }
        } else {
          // 判断是否为“学习中心”或“个人中心”
          if (item.columnName === '学习中心' || item.columnName === '个人中心') {
            if (!this.user) {
              this.$message.warning('请先登录')
              this.$login.show() // 调用登录弹窗（根据你的实际方法名调整）
              return
            }
          }

          // 更新激活状态
          this.activeTab = item.id
          this.$store.commit('SET_COLUMNITEM', item)
          this.$store.commit('SET_COLUMNITEM_PARENT', item)
          this.$store.commit('SET_ACTIVEINDEX', item.id)

          if (item.isExtralinks === 0) {
            this.$router.push({
              path: '/' + item.columnCode,
              query: { columnId: item.id, activeChildrenIndex: item.id },
              name: item.columnCode
            })
          } else {
            this.$router.push({ path: '/secondlist', query: { activeChildrenIndex: item.id } })
          }
        }
      } else {
        // 默认跳转首页
        this.activeTab = 'home'
        this.$store.commit('SET_COLUMNITEM', [])
        this.$store.commit('SET_COLUMNITEM_PARENT', [])
        this.$store.commit('SET_ACTIVEINDEX', '')
        this.$router.push({ path: '/' })
      }
    }
  }
}
</script>

<style scoped>
.main-core-content {
  width: 80%;
  margin: 0 auto;
}

.navbar {
  display: flex;
  justify-content: space-between;
  width: 75%;
  height: 80px;
  align-items: center;
  margin: auto;
}

.left-section {
  flex: 1;
  max-width: 478px;
  min-width: 378px;
}

.logo {
  width: 100%;
  height: auto;
}

.right-section {
  flex: 1;
  min-width: 800px;
  display: flex;
  justify-content: flex-end;
}

.nav-links {
  display: flex;
  gap: 17px;
  list-style: none;
  margin: 0;
  padding: 0;
  align-items: center;
}
/* 用户头像容器 */
.user-avatar-container {
  position: relative;
  display: inline-block;
  cursor: pointer;
  padding: 2px;
}

.common-img{
  height: 50px;
  cursor: pointer;
  position: relative;
  top: 3px;
  width: 50px;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.common-img:hover {
  box-shadow: 0 0 8px rgba(42, 120, 255, 0.5);
}

.user-dropdown {
  position: absolute;
  top: 55px;
  left: -50px;
  width: 160px;
  background-color: #FFFFFF;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  padding: 8px 0;
  border: 1px solid #f0f0f0;
  margin-top: -2px;
}

.dropdown-menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

.dropdown-item {
  height: 40px;
  line-height: 40px;
  padding: 0 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
}

.dropdown-item:hover {
  background-color: #EEF5FF;
  color: #2A78FF;
}

.item-text {
  font-size: 14px;
  color: #333333;
  font-weight: 500;
}

.dropdown-divider {
  height: 1px;
  margin: 4px 0;
  background-color: #f0f0f0;
}

.logout-item .item-text {
  color: #FC1F1F;
}

.logout-item:hover .item-text {
  color: #FC1F1F;
}

.main-core-content.full-width{
  width: 100%;
  margin: 0;
}

.login-font {
  font-weight: 500;
  font-size: 16px;
  color: #666666;
  padding-top: 1px;
  cursor: pointer;
}

.login-li {
  padding-top: 1px;
  margin-left: 25px;
  cursor: pointer;
  position: relative;
}

.nav-item {
  text-decoration: none;
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  padding: 6px 17px;
  border-radius: 50px;
  transition: all 0.3s ease;
  cursor: pointer;
}

/* 激活状态样式 */
.nav-item.active {
  background-color: #2A78FF;
  color: #FFFFFF;
}
.register-span:hover {
  color: #2A78FF;
}
/* 悬停样式 */
.nav-item:hover {
  background-color: #2A78FF;
  color: #FFFFFF;
}
</style>
